import { useState } from 'react';
import { toE164 } from './lib/csv.js';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '+', '0', '⌫'];

export default function ManualDialPad({ canDial, busy, onDial }) {
  const [number, setNumber] = useState('');
  const [error, setError] = useState('');

  function press(key) {
    setError('');
    if (key === '⌫') {
      setNumber((current) => current.slice(0, -1));
      return;
    }
    setNumber((current) => `${current}${key}`);
  }

  async function dial() {
    const normalized = toE164(number);
    if (!/^\+[1-9]\d{6,14}$/.test(normalized)) {
      setError('Enter a valid phone number, including area code.');
      return;
    }
    const started = await onDial(normalized);
    if (started) setNumber(normalized);
  }

  const unavailable = busy ? 'Finish the active session first.' : 'Go online before dialing.';

  return (
    <section className="panel manual-dial">
      <div className="panel__head">
        <h3 className="panel__title">Quick dial</h3>
        {number && <button type="button" className="btn btn--ghost" onClick={() => { setNumber(''); setError(''); }}>Clear</button>}
      </div>
      <label className="field field--block">
        Phone number
        <input className="manual-dial__input mono" type="tel" inputMode="tel" autoComplete="tel"
          placeholder="(305) 555-0123" value={number}
          onChange={(event) => { setNumber(event.target.value); setError(''); }} />
      </label>
      <div className="dial-pad" aria-label="Dial pad">
        {KEYS.map((key) => <button key={key} type="button" className="dial-pad__key" aria-label={key === '⌫' ? 'Delete digit' : key}
          onClick={() => press(key)}>{key}</button>)}
      </div>
      {error && <p className="manual-dial__error" role="alert">{error}</p>}
      <button type="button" className="btn btn--primary btn--block manual-dial__call" onClick={dial} disabled={!canDial || !number.trim()}>
        <span aria-hidden="true">☎</span> Dial number
      </button>
      <p className="manual-dial__hint">{canDial ? 'Only call a number you control or have consent to call.' : unavailable}</p>
    </section>
  );
}
